import { useEffect, useState } from "react";

const TARGET = new Date("2026-09-14T23:59:59").getTime();

export default function Countdown() {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  const left = Math.max(0, TARGET - now);
  const cells = [
    { v: Math.floor(left / 86400000), l: "Days" },
    { v: Math.floor((left % 86400000) / 3600000), l: "Hours" },
    { v: Math.floor((left % 3600000) / 60000), l: "Min" },
    { v: Math.floor((left % 60000) / 1000), l: "Sec" },
  ];

  return (
    <div data-testid="offer-countdown" className="mt-12 text-center">
      <p className="text-[10px] uppercase tracking-[0.35em] ff-sans" style={{ color: "#ff7fbf" }}>
        Limited-time introductory pricing ends in
      </p>
      <div className="mt-4 flex items-start justify-center gap-3 sm:gap-5">
        {cells.map((c) => (
          <div key={c.l} className="border hairline-gold bg-white/[0.02] px-4 py-3 sm:px-6 sm:py-4">
            <p className="ff-serif text-4xl sm:text-5xl font-light gold-text tabular-nums">
              {String(c.v).padStart(2, "0")}
            </p>
            <p className="mt-1 text-[9px] uppercase tracking-[0.3em] text-[#f7e7ce]/50 ff-sans">{c.l}</p>
          </div>
        ))}
      </div>
      <p className="mt-4 text-[11px] font-light tracking-wide text-[#f7e7ce]/55 ff-sans">
        Then the Portal returns to <span className="line-through">$97</span> → $127 a bottle.
      </p>
    </div>
  );
}
